"use strict";
/**
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/vercel/path1/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path1/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path1/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path1/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path1/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");
/**
 * Component that inline-includes a JSON-LD script where specified.
 *
 * @example
 * ```tsx
 * <JsonLd<Person>
 *   item={{
 *     "@context": "https://schema.org",
 *     "@type": "Person",
 *     name: "Grace Hopper",
 *     alternateName: "Grace Brewster Murray Hopper",
 *     alumniOf: {
 *       "@type": "CollegeOrUniversity",
 *       name: ["Yale University", "Vassar College"]
 *     },
 *     knowsAbout: ["Compilers", "Computer Science"]
 *   }}
 * />
 * ```
 */


var JsonLd =
/*#__PURE__*/
function (_React$Component) {
  _inherits(JsonLd, _React$Component);

  function JsonLd() {
    _classCallCheck(this, JsonLd);

    return _possibleConstructorReturn(this, _getPrototypeOf(JsonLd).apply(this, arguments));
  }

  _createClass(JsonLd, [{
    key: "render",
    value: function render() {
      return React.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(this.props.item)
        }
      });
    }
  }]);

  return JsonLd;
}(React.Component);

exports.JsonLd = JsonLd;